// API client per gestire budget annuali dei progetti (project_year)
// Segue pattern FK esterno: /api/v1/project/project/<id>/year/<year>

const API_BASE = '/api/v1/project/project'

/**
 * Client API per project_year con gestione FK (id_project, year) esterna al DBMng
 * Pattern URL: /project/<id>/year/<year> 
 * FK gestite nei parametri URL, DBMng gestisce solo il campo budget
 */
const projectYearAPI = {
  /**
   * Ottieni tutti i budget anni per un progetto + schema DBMng
   * GET /api/v1/project/project/<id>/year
   */
  async getAllYears(projectId) {
    try {
      const response = await fetch(`${API_BASE}/${projectId}/year`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const result = await response.json()
      
      if (!response.ok) {
        console.error('Errore getAllYears:', result)
        return {
          ok: false,
          message: result.message || `Errore HTTP ${response.status}`
        }
      }

      return {
        ok: true,
        data: result.data || [],
        dbmng: result.dbmng // Schema DBMng per il form
      }
    } catch (error) {
      console.error('Errore di connessione getAllYears:', error)
      return {
        ok: false,
        message: 'Errore di connessione al server'
      }
    }
  },

  /**
   * Ottieni dettagli di un progetto specifico
   * GET /api/v1/project/project/<id>
   */
  async getProject(projectId) {
    try {
      const response = await fetch(`${API_BASE}/${projectId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const result = await response.json()      

      return result;
    } catch (error) {
      console.error('Errore di connessione getProject:', error)
      return {
        ok: false,
        message: 'Errore di connessione al server'
      }
    }
  },

  /**
   * Crea nuovo budget per un anno specifico
   * POST /api/v1/project/project/<id>/year/<year>
   * Body: { budget: float }
   */
  async create(projectId, year, budgetData) {
    try {
      if (!budgetData.budget) {
        return {
          ok: false,
          message: 'Budget richiesto'
        }
      }

      const response = await fetch(`${API_BASE}/${projectId}/year/${year}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(budgetData)
      })

      const result = await response.json()
      
      if (!response.ok) {
        console.error('Errore create:', result)
        return {
          ok: false,
          message: result.message || `Errore HTTP ${response.status}`
        }
      }

      return {
        ok: true,
        message: result.message || 'Budget creato con successo',
        data: result.data
      }
    } catch (error) {
      console.error('Errore di connessione create:', error)
      return {
        ok: false,
        message: 'Errore di connessione al server'
      }
    }
  },

  /**
   * Aggiorna budget esistente per un anno
   * PUT /api/v1/project/project/<id>/year/<year>
   * Body: { budget: float }
   */
  async update(projectId, year, budgetData) {
    try {
      if (!budgetData.budget) {
        return {
          ok: false,
          message: 'Budget richiesto'
        }
      }

      const response = await fetch(`${API_BASE}/${projectId}/year/${year}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(budgetData)
      })

      const result = await response.json()
      
      if (!response.ok) {
        console.error('Errore update:', result)
        return {
          ok: false,
          message: result.message || `Errore HTTP ${response.status}`
        }
      }

      return {
        ok: true,
        message: result.message || 'Budget aggiornato con successo',
        data: result.data
      }
    } catch (error) {
      console.error('Errore di connessione update:', error)
      return {
        ok: false,
        message: 'Errore di connessione al server'
      }
    }
  },

  /**
   * Elimina budget per un anno
   * DELETE /api/v1/project/project/<id>/year/<year>
   */
  async delete(projectId, year) {
    try {
      const response = await fetch(`${API_BASE}/${projectId}/year/${year}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const result = await response.json()
      
      if (!response.ok) {
        console.error('Errore delete:', result)
        return {
          ok: false,
          message: result.message || `Errore HTTP ${response.status}`
        }
      }

      return {
        ok: true,
        message: result.message || 'Budget eliminato con successo'
      }
    } catch (error) {
      console.error('Errore di connessione delete:', error)
      return {
        ok: false,
        message: 'Errore di connessione al server'
      }
    }
  },

  /**
   * Utility: formatta valuta per visualizzazione
   */
  formatCurrency(value) {
    if (!value) return '€ 0,00'
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(parseFloat(value))
  },

  /**
   * Utility: valida anno
   */
  isValidYear(year) {
    const currentYear = new Date().getFullYear()
    const numYear = parseInt(year)
    return numYear >= 2020 && numYear <= currentYear + 10
  },

  /**
   * Utility: valida budget
   */
  isValidBudget(budget) {
    const numBudget = parseFloat(budget)
    return !isNaN(numBudget) && numBudget >= 0
  }
}

export default projectYearAPI